import React, { forwardRef } from 'react';

import { MenuButton as ChakraMenuButton } from '@chakra-ui/react';

import { ChevronDown } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

export const MenuButton = ({
  children,
  as = forwardRef((props, ref) => <Button ref={ref} variant="tertiary" p={0} {...props} />),
  ...props
}) => (
  <ChakraMenuButton
    sx={{
      p: {
        margin: '0',
      },
      svg: {
        transition: 'transform 150ms ease-in-out',
      },
      '&[aria-expanded="true"]': {
        svg: {
          transform: 'rotate(180deg)',
        },
      },
    }}
    as={as}
    EndIcon={ChevronDown}
    {...props}
  >
    {children}
  </ChakraMenuButton>
);
